import {
  createRouter,
  createWebHashHistory,
  createMemoryHistory,
} from "vue-router";
import {
  HTTP_ALB
} from '../service/axios.js'
import { getPermissionList, transform } from "../config/roleauthlist.js";
// 动态解析当前路由模块下的文件
const importFile = require.context("@/router", false, /\.js$/);
const lib = importFile.keys();
const fileObj = {};
// 路由白名单
const tokenWhiteList = ["login", "index"];

// auth白名单，在此名单中的路由name有权限查看页面；
// const authWhiteList = [...tokenWhiteList]
// auth黑名单，在此名单中的路由name统一无权限查看页面；
let authBlackList = []
// 按钮权限池
let btnPermissionList = [];
// 动态导入路由文件
function importAll(r) {
  r.keys().forEach((key) => {
    fileObj[key] = r(key).default;
  });
}
importAll(importFile);
const routerArry = lib.filter((file, index) => {
  return file !== "./index.js";
});
const routeList = [];
routerArry.forEach((routerItem) => {
  routeList.push(fileObj[routerItem]);
});
const routes = routeList.flat();
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
let tokenWhitePathList = ["/login"];
// 路由守卫
router.beforeEach(async (to, from, next) => {
  // console.log(to, from, '获取路由', window.location.href)
  // alert(JSON.stringify(to) , JSON.stringify(from))
  // if (window.location.host == 'compass.jinritemai.com') {
  //   return next('/admin/room/roomMage')
  // }
  if (to.query.token) {
    localStorage.removeItem('dialogTableVisibleType')
    try {
      const token=to.query.token
      localStorage.setItem('token', token)
      localStorage.setItem('HSUC_LOGIN_INFO', JSON.stringify({token}))
      HTTP_ALB.get('/user/self/get').then((res) => {
        let params = {
          user_name:  res.user_realname,
          uid: res.user_id,
          nickname:  res.user_realname,
          headimgurl: res.user_picture,
          email: res.email,
          user_topsign: res.user_topsign,
          company_parent_id: res.company_parent_id,
          company_type: res.company_type,
        }
        localStorage.setItem("uid", res.user_id)
        localStorage.setItem("userInfo", JSON.stringify(params))
        localStorage.setItem('dialogTableVisibleType',1)
        localStorage.setItem('authScope',res.auth_scope)
      },
      (err) => {
        console.log(err, '获取tokenError')
      }
      )
      // setTimeout(async()=>{llllllllllllll,,,bnbnnvb fvhkfykgykguk
      // await getUserInfo(token)
       next('/admin/home')
      // })
    } catch (error) {
      console.log(error)
    }
    return next('/admin/home')
  }
  // 白名单校验
  // if (tokenWhiteList.includes(to.name)) {
  //   let tokens = localStorage.getItem('token')
  //   if(to.name=='login' && !tokens){
  //       window.location.href=process.env.VUE_APP_ADSS_URL + '?type=ALB'
  //       return
  //   }
  //   return next();
  // }
  //   // 白名单校验
  if (tokenWhitePathList.includes(to.path)) {
    // if(to.name=='login'){
    //    window.location.href=process.env.VUE_APP_ADSS_URL + '?type=ALB'
    //   return
    // }
    return next();
  }
  // 实时获取权限；创建页面权限池和按钮权限池；默认全部都有权限；
  async function getpermissionlist() {
   await getPermissionList()
      .then((res) => {
        const permissionObj = transform(res.role_power_menu || []);
        localStorage.setItem("PERMISSION_LIST", JSON.stringify(permissionObj));
        const btnArray = [];
        for (const key in permissionObj) {
          const btn = permissionObj[key];
          btnArray.push(btn);
        }
        let role_power_menu =  res.role_power_menu || []
        let btnPermissionList = role_power_menu.filter((v) => v.has_role)
        let arr = []
        btnPermissionList.forEach((item) => {
          arr.push(item.router_node)
        })
        localStorage.setItem(
          "qcBtnPermissionList",
          JSON.stringify(arr  || [])
        );
         authBlackList = []
        if (permissionObj[to.name]) {
          if (
            permissionObj[to.name].length > 0 &&
            permissionObj[to.name].includes("LOOK")
          ) {
            to.meta.btnPermission = permissionObj[to.name];
          } else {
            authBlackList.push(to.name);
          }
        }
        return authBlackList;
      })
      .then((res) => {
        if (authBlackList.includes(to.name)) {
          window.location.replace("/#/notPermission");
        }
      });
  }
  if (from.path === "/login") {
    await getpermissionlist()
  } else {
    getpermissionlist()
  }
  if (!localStorage.getItem("token")) {
    window.location.replace("/#/login");
    //  window.location.href=process.env.VUE_APP_ADSS_URL + '?type=ALB'
  } else {
    return next();
  }
});

export default router;
